// Product page: gallery, variant change, quantity tiers, add to cart, sticky bar.
const section = document.querySelector('[data-product-section]');

if (section) {
  const $ = (s, r = section) => r.querySelector(s);
  const $$ = (s, r = section) => [...r.querySelectorAll(s)];
  const sectionId = section.dataset.sectionId;
  const productUrl = section.dataset.productUrl;
  const data = JSON.parse(document.querySelector('[data-product-json]').textContent);
  const form = $('[data-product-form]');
  const idInput = $('[data-variant-id]', form);
  const sticky = document.querySelector('[data-sticky-atc]');
  const error = $('[data-product-error]');

  /* Gallery: thumbs scroll the track, the track updates the active thumb, image click opens zoom */
  const track = $('[data-gallery-track]');
  const thumbs = $$('[data-thumb]');
  const goTo = (index, smooth = true) => {
    if (!track) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  };
  thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
  track?.addEventListener('scroll', () => {
    const index = Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
  }, { passive: true });

  const zoom = document.getElementById(`Zoom-${sectionId}`);
  const openZoom = (target) => {
    if (!zoom) return;
    zoom.showModal();
    zoom.querySelector(`[data-zoom-index="${target.dataset.zoom}"]`)?.scrollIntoView();
  };
  section.addEventListener('click', (e) => {
    const target = e.target.closest('[data-zoom]');
    if (target) openZoom(target);
  });
  section.addEventListener('keydown', (e) => {
    const target = e.target.closest('[data-zoom]');
    if (target && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openZoom(target); }
  });

  /* Quantity tiers: a tile sets the quantity the button adds */
  const setQuantity = (qty) => {
    const field = $('[data-quantity-value]', form);
    if (field) field.value = qty;
    $$('[data-tier-offer] .tier-tile').forEach((tile) => tile.setAttribute('aria-pressed', String(Number(tile.dataset.qty) === qty)));
  };
  section.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-tier-offer] .tier-tile');
    if (tile) setQuantity(Number(tile.dataset.qty));
  });

  /* Variant change: update URL and form, re-render price, button, delivery and sticky bar from the server */
  let controller;
  const selectVariant = async (variant) => {
    if (!variant) return;
    idInput.value = variant.id;
    idInput.dispatchEvent(new Event('change', { bubbles: true })); // payment terms and express buttons listen to this
    history.replaceState(null, '', `${productUrl}?variant=${variant.id}`);

    $$('[data-variant-picker] fieldset').forEach((fs, i) => {
      const label = fs.querySelector('[data-selected-value]');
      if (label) label.textContent = variant.options[i];
      fs.querySelectorAll('input').forEach((input) => { input.checked = input.value === variant.options[i]; });
    });
    const select = sticky?.querySelector('[data-sticky-variant]');
    if (select) select.value = variant.id;

    if (variant.media && track) {
      const index = $$('[data-media-id]', track).findIndex((s) => Number(s.dataset.mediaId) === variant.media);
      if (index >= 0) goTo(index);
    }

    controller?.abort();
    controller = new AbortController();
    try {
      const res = await fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`, { signal: controller.signal });
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      doc.querySelectorAll('[data-swap]').forEach((fresh) => {
        document.querySelector(`[data-swap="${fresh.dataset.swap}"]`)?.replaceWith(fresh);
      });
      setQuantity(1);
    } catch (err) {
      if (err.name !== 'AbortError') console.error(err);
    }
  };

  const findVariant = (changedIndex) => {
    const chosen = $$('[data-variant-picker] fieldset').map((fs) => fs.querySelector('input:checked')?.value);
    const exact = data.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    if (exact) return exact;
    // No such combination: keep the value just picked and take the first available variant that has it.
    const picked = chosen[changedIndex];
    return data.variants.find((v) => v.available && v.options[changedIndex] === picked)
      || data.variants.find((v) => v.options[changedIndex] === picked);
  };

  section.addEventListener('change', (e) => {
    const input = e.target.closest('[data-variant-picker] input');
    if (input) selectVariant(findVariant(Number(input.dataset.optionIndex)));
  });
  sticky?.addEventListener('change', (e) => {
    if (e.target.matches('[data-sticky-variant]')) selectVariant(data.variants.find((v) => v.id === Number(e.target.value)));
  });

  /* Add to cart without reload, from the main button or the sticky bar */
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const pressed = e.submitter?.closest('[data-add-to-cart]') || document.querySelector('[data-add-to-cart]');
    error.hidden = true;
    window.Pleassy.buttonState(pressed, 'busy');
    try {
      await window.Pleassy.addToCart(new FormData(form));
      window.Pleassy.buttonState(pressed, 'added');
    } catch (err) {
      window.Pleassy.buttonState(pressed, null);
      error.textContent = err.message;
      error.hidden = false;
    }
  });

  /* Sticky bar: visible once the main button has scrolled out of view, hidden again at the footer */
  if (sticky) {
    let pastButton = false;
    let atFooter = false;
    const update = () => {
      const show = pastButton && !atFooter;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelectorAll('button, select').forEach((el) => { el.tabIndex = show ? 0 : -1; });
    };
    new IntersectionObserver(([entry]) => {
      pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe($('.product__buttons'));
    const footer = document.querySelector('.footer');
    if (footer) new IntersectionObserver(([entry]) => { atFooter = entry.isIntersecting; update(); }).observe(footer);
  }
}
